<div class="container" role="main">
    <form class="nonEnumeratedproviderForm">
        <div class="row main-home">
            <div class="col-md-12">
                <button type="button" class="greyBtn" (click)="back()"
                    style="font-weight : bold;">Go To Previous Section</button>&nbsp;
                <button type="button" class="greyBtn" *ngIf="isInstruction" (click)="openInstruction()"
                    style="font-weight : bold;">Instructions</button>&nbsp;
                <button type="button" class="orangeBtn ml-5" *ngIf="isFormsValid" (click)="nonEnumeratedProviderDetailsSubmit()" [ngStyle]="{'background-color': primaryColor}">Proceed
                        to Next Section</button>
            </div>
        </div>
        <div class="row main-home py-0">
            <div class="col-md-12">
                <p role="heading" aria-level="1">Please enter any information you have regarding the {{title}}</p>
            </div>
        </div>
        <div class="row main-home" *ngIf="isNameRequired">
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <span class="col-form-label" style="font-size:14px;"  *ngIf="isNameRequired">
                    Organization Name or First & Last Name Required
                </span>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
            </div>
        </div>
        <div class="row main-home" role="form">
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center" [formGroup]="nonEnumeratedProviderFormPart1">
                <app-json-form *ngIf="isformloaded" [controlsData]="nonEnumeratedProviderFormData1.controls" [formData]="nonEnumeratedProviderFormPart1"
                    (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
                <button type="button" class="orangeBtn" style="float: left;" *ngIf="isFormsValid" (click)="nonEnumeratedProviderDetailsSubmit()" [ngStyle]="{'background-color': primaryColor}">Proceed
                        to Next Section</button>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center" [formGroup]="nonEnumeratedProviderFormPart2">
                <app-json-form *ngIf="isformloaded" [controlsData]="nonEnumeratedProviderFormData2.controls" [formData]="nonEnumeratedProviderFormPart2"
                    (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center" [formGroup]="nonEnumeratedProviderFormPart3">
                <app-json-form *ngIf="isformloaded" [controlsData]="nonEnumeratedProviderFormData3.controls" [formData]="nonEnumeratedProviderFormPart3"
                    (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </div>
        </div>
        
    </form>
</div>